const AccionesPublicacionConvocatoriaCC = () => {
  return <div>AccionesPublicacionConvocatoriaCC</div>;
};

export default AccionesPublicacionConvocatoriaCC;
